import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import LinearProgress from '@material-ui/core/LinearProgress';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

//Others
import { withStyles } from '@material-ui/core/styles';
import { Component } from 'react';
import { compose } from 'recompose';
import MaterialTable from 'material-table'

//Icons
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

//Components
import LoadingBackdrop from '../../public/components/LoadingBackdrop';

//Others
const axios = require('axios').default;
const FormData = require('form-data');
const api_base_url = "https://e-learning-be-ybcs6wa7da-as.a.run.app";

const useStyles = theme => ({
    root: {
        margin: 15,
        marginTop: 50
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class RescoreReportsTable extends Component {
    constructor() {
        super()
        this.state = {
            testsToShow: [],
            isLoading: false
        };
    }

    componentDidMount = async () => {
        this.setState({
            isLoading: true
        });

        await this.handleGetAllSubmittedProblems();

        this.setState({
            isLoading: false
        });
    }

    handleGetAllSubmittedProblems = async () => {
        try {
            const problemsToShow = [];
            const res = await axios({
                method: 'get',
                url: 'https://chatter-funky-busby.glitch.me/test/problems?problemType=rescore',
            });

            const resData = res.data;
            await resData.problems.map((problem) => {
                problemsToShow.push({
                    submittedTestId: problem.submittedTestId,
                    submitter: problem.submitter,
                    topic: problem.topic,
                    description: problem.description,
                    teacherName: problem.teacherName,
                    status: problem.status,
                    createdAt: new Date(problem.createdAt).toDateString()
                })
            })
            this.setState({
                problemsToShow: problemsToShow
            });

        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Grid item xs={12}>
                <LoadingBackdrop isLoading={this.state.isLoading} />
                <MaterialTable
                    data={this.state.problemsToShow}
                    columns={[
                        {
                            title: 'Test id',
                            field: 'submittedTestId',
                            editable: 'never'
                        },
                        {
                            title: 'Submitter',
                            field: 'submitter',
                            editable: 'never'
                        },
                        {
                            title: 'Topic',
                            field: 'topic',
                            editable: 'never'
                        },
                        {
                            title: 'Description',
                            field: 'description',
                            editable: 'never'
                        },
                        {
                            title: 'Assign to',
                            field: 'teacherName',
                            editable: 'never'
                        },
                        {
                            title: 'Created',
                            field: 'createdAt',
                            editable: 'never',
                            defaultSort: 'desc',
                            customSort: (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                        },
                        {
                            title: 'Status',
                            field: 'status',
                            editable: 'never'
                        }
                    ]}
                    options={{
                        actionsColumnIndex: -1,
                        exportAllData: true,
                        exportButton: true,
                        grouping: true,
                        pageSize: 10
                    }}
                    title='Rescore reports'
                />
            </Grid>
        )
    }
}
export default compose(
    withStyles(useStyles)
)(RescoreReportsTable);